"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichTextDisplay = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const draft_js_1 = require("draft-js");
const utils_1 = require("../../utils");
const media_1 = require("../media");
const link_1 = require("../link");
const RichTextDisplay = props => {
    const { data, customControls = [] } = props;
    const decorator = new draft_js_1.CompositeDecorator([
        {
            strategy: link_1.findLinkEntities,
            component: link_1.Link,
        },
    ]);
    if (!data) {
        return null;
    }
    const editorState = draft_js_1.EditorState.createWithContent((0, draft_js_1.convertFromRaw)(JSON.parse(data)), decorator);
    const handleChange = () => { };
    const blockRenderer = (contentBlock) => {
        const blockType = contentBlock.getType();
        if (blockType === "atomic") {
            const contentState = editorState.getCurrentContent();
            const entity = contentBlock.getEntityAt(0);
            if (entity) {
                const type = contentState.getEntity(entity).getType();
                if (type === "IMAGE") {
                    return {
                        component: media_1.Media,
                        editable: false,
                        props: contentState.getEntity(contentBlock.getEntityAt(0)).getData(),
                    };
                }
                else {
                    const block = (0, utils_1.atomicBlockExists)(type.toLowerCase(), customControls);
                    if (block) {
                        return {
                            component: block.atomicComponent,
                            editable: false,
                            props: contentState.getEntity(contentBlock.getEntityAt(0)).getData(),
                        };
                    }
                }
            }
        }
        return null;
    };
    return (0, jsx_runtime_1.jsx)(draft_js_1.Editor, { blockRendererFn: blockRenderer, editorState: editorState, readOnly: true, onChange: handleChange });
};
exports.RichTextDisplay = RichTextDisplay;
//# sourceMappingURL=index.js.map